import React, { useState, useEffect } from 'react';
import NavBar from './layouts/NavBar';
import { Container, Button, Col, Form, Row, Table, Spinner, Card, Alert, InputGroup } from 'react-bootstrap';
import Footer from './layouts/Footer';
import { getReservaPorConfirmationId, actualizarPerfilHuesped, getBuscarReservas, CreateProfile, UpdateReservation, createAlert, removerHabitacionAsignada  } from '../utils/Api';
import { buscarHabitacionesDisponibles } from '../utils/Api'; // Para la búsqueda de habitaciones
import { asignarNumeroHabitacion } from '../utils/Api';
import { realizarCheckIn } from '../utils/Api';
//import { getHabitacionesHotelDisponibles } from '../utils/Api';

import { Modal } from 'react-bootstrap'; // Asegúrate de importar Modal desde react-bootstrap
import { CountryCodes } from './layouts/CountryCodes';
import { CountriesISO } from './layouts/CountriesISO';
import { ProfileDetails } from '../classes/ProfileDetails';
import  ReservationDetails from '../classes/ReservationDetails';

import { Badge } from 'react-bootstrap'; // Importa Badge de react-bootstrap

const ROOM_CATEGORIES_BY_UNIT = {
    CHLPBCH:    ['KND1', 'QND2', 'KNDA', 'KNXI'],                                      // Radisson Blu
    PEBEBRO: ['SET','SQM','SETS','SEQS','SEQ','SEKS','SEK','SGL','PRS','PKT','PKQ'] // Ebro
  };
  
  // Aliases para normalizar claves
  const UNIT_ALIAS = {
    CHLPBCH: 'CHLPBCH',
    PBCH:    'CHLPBCH',   // compatibilidad hacia atrás
    BLU:     'CHLPBCH',
    RADISSON:'CHLPBCH',
    PEBEBRO: 'PEBEBRO',
    HEBRO:   'PEBEBRO'
  };
  const resolveUnitKey = (u) => UNIT_ALIAS[(u || '').toUpperCase()] || 'CHLPBCH';

const countryCodes = CountryCodes;
const countriesISO = CountriesISO;
const FormularioBusquedaReserva = () => {
  const [showModal, setShowModal] = useState(false);
  // recuerda la unidad con la que se abrió el modal la última vez
  const [lastUnitForModal, setLastUnitForModal] = useState(resolveUnitKey(localStorage.getItem('businessUnit')));

  const [showRoomModal, setShowRoomModal] = useState(false); // Controla la visibilidad del modal de habitaciones
  const [availableRooms, setAvailableRooms] = useState([]); // Lista de habitaciones disponibles
  const [selectedRoom, setSelectedRoom] = useState(null); // Habitación seleccionada
  const [isLoadingRooms, setIsLoadingRooms] = useState(false); // Indicador de carga de habitaciones
  const [roomError, setRoomError] = useState(''); 
  
  const [description, setDescription] = useState('');
  const [selectedRoomStatuses, setSelectedRoomStatuses] = useState([]);
  //const [selectedFORoomStatuses] = useState([]);
  const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);
  const [roomTypeInitialized, setRoomTypeInitialized] = useState(false);

  const roomStatusesOptions = ['Clean', 'Dirty', 'Inspected', 'OutOfService'];

  const [roomTypeOptions, setRoomTypeOptions] = useState(
    ROOM_CATEGORIES_BY_UNIT[resolveUnitKey(localStorage.getItem('businessUnit'))] || []
  );

  const [checkInError, setCheckInError] = useState('');


const [isAssigningRoom, setIsAssigningRoom] = useState(false); // Estado para el proceso de asignación
const [assignmentError, setAssignmentError] = useState(''); // Mensaje de error en la asignación

const [isCheckInEnabled, setIsCheckInEnabled] = useState(false); // Controla si el botón está habilitado
const [isPerformingCheckIn, setIsPerformingCheckIn] = useState(false); // Controla si el check-in está en progreso

  const handleModalOpen = () => {
  const unitNow = resolveUnitKey(localStorage.getItem('businessUnit'));

  // ⚠️ si cambió la unidad desde la última vez, resetea y recarga opciones
  if (unitNow !== lastUnitForModal) {
    setRoomTypeOptions(ROOM_CATEGORIES_BY_UNIT[unitNow] || []);
    setModalSearchResults(null);
    setHasSearched(false);
    setModalError('');
    setModalPagination({ offset: 0, limit: 20, totalResults: 0 });
    setModalFormData(prev => ({
      ...prev,
      roomType: '',
      givenName: '',
      surname: '',
      arrivalStartDate: getTodayDateForInput(), // si ya lo tienes utilízalo
      departureStartDate: ''
    }));
    if (typeof setSelectedRoomTypes === 'function') setSelectedRoomTypes([]);
    if (typeof setRoomTypeInitialized === 'function') setRoomTypeInitialized(false);
  }

  setLastUnitForModal(unitNow);
  setShowModal(true);
};

  const handleModalClose = () => setShowModal(false);
  const [confirmationId, setConfirmationId] = useState('');
  const [reservationData, setReservationData] = useState(null);
  const hotelId = reservationData?.hotelId;
  const reservationId = reservationData?.reserva?.idReserva;
  const [selectedReservationId, setSelectedReservationId] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  const [desasignandoId, setDesasignandoId] = useState(null);
  const [desasignadoExitosoId, setDesasignadoExitosoId] = useState(null);

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Estado para el loader
  const [formData, setFormData] = useState({
    email: '',
    rut: '',
    identificationType: '3', // 3 = RUT, 5 = Pasaporte
    nameFirst: '',
    nameSur: '',
    phoneNumber: '',
    address1: '',
    address2: '',
    city: '',
    countryCode: '',
    codigoPais: '',
    codigoPostal: '',
    taxType: '',
    reservationId: '',
    profileId: '',
    postingRestriction: false,
    FechaNacimiento: "",
    Language: "ES"
  });

  
  const [canCreateKey, setCanCreateKey] = useState(false);


  const [inputConfirmationId, setInputConfirmationId] = useState(''); // Estado temporal para el input
  
  const handleCheckIn = async () => {
    if (!selectedRoom) {
      alert("Primero debes asignar una habitación antes de realizar el check-in.");
      return;
    }
  
    setIsPerformingCheckIn(true);
    setCheckInError("");
  
    try {
      const checkInRequest = {
        reservation: {
          roomId: selectedRoom.roomId,
          ignoreWarnings: true,
          stopCheckin: false,
          printRegistration: false,
        },
        fetchReservationInstruction: [],
        includeNotifications: false,
      };
  
      console.log("Payload de CheckInRequest:", JSON.stringify(checkInRequest));
  
      const result = await realizarCheckIn(reservationData.reserva.idReserva, checkInRequest);
  
      if (result) {
        alert("Check-in realizado correctamente.");
      }
      setCanCreateKey(true);
    } catch (error) {
      const formattedError = `${error.detail || error.message}`;
      setCheckInError(formattedError);
    } finally {
      setIsPerformingCheckIn(false);
    }
  };  


const handleAssignRoom = async () => {
  if (!selectedRoom) {
    alert("Primero debes seleccionar una habitación.");
    return;
  }

  if (!reservationData || !reservationData.reserva) {
    alert("No hay una reserva válida para asignar la habitación.");
    return;
  }

  setIsAssigningRoom(true);
  setAssignmentError('');

  try {
    const roomAssignmentRequest = {
      criteria: {
        hotelId: reservationData.hotelId,
        reservationIdList: [
          {
            id: reservationData.reserva.idReserva,
            type: "Reservation"
          }
        ],
        roomId: selectedRoom.roomId, // ⚠️ Asegúrate que selectedRoom.roomId esté bien seteado
        updateRoomTypeCharged: false,
        roomNumberLocked: true
      }
    };

    const success = await asignarNumeroHabitacion(reservationData.reserva.idReserva, roomAssignmentRequest);

    if (success) {
      alert("Habitación asignada correctamente.");
      setIsCheckInEnabled(true);
    } else {
      setAssignmentError("No se pudo asignar la habitación. Intenta nuevamente.");
    }
  } catch (error) {
    console.error("Error al asignar la habitación:", error);
    setAssignmentError("Error en la asignación de habitación. Verifica la consola.");
  } finally {
    setIsAssigningRoom(false);
  }
};


  const handleChanged = (e) => {
    setInputConfirmationId(e.target.value); // Permite escribir sin bloquear el campo
  };

  const handleExitReservation = () => {
    setConfirmationId('');
    setSelectedReservationId('');
    setReservationData(null);
    setIsPerformingCheckIn(false);
    setCanCreateKey(false);
    setAccompanyingPersons([]);
    setRoomTypeInitialized(false);
    setFormData({
      email: '',
      rut: '',
      identificationType: '3',
      nameFirst: '',
      nameSur: '',
      phoneNumber: '',
      address1: '',
      address2: '',
      city: '',
      countryCode: '',
      postalCode: '',
      taxType: '',
      hotelId: '',
      reservationId: '',
      profileId: '',
      FechaNacimiento: '',
      Language: 'ES',
      fechaNacimiento: '',
      currencyCode: 'CLP',
    });
  };

  const getTodayDateForInput = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [clienteId, setClienteId] = useState(null); // Nuevo estado para almacenar el idCliente
  const [modalFormData, setModalFormData] = useState({
    givenName: '',
    surname: '',
    arrivalStartDate: getTodayDateForInput(),
    departureStartDate: ''
  });
  const [modalSearchResults, setModalSearchResults] = useState(null);
  const [modalPagination, setModalPagination] = useState({
    offset: 0,
    limit: 20,
    totalResults: 0
  });
  const [modalIsLoading, setModalIsLoading] = useState(false);
  const [modalError, setModalError] = useState('');
  const [accompanyingPersons, setAccompanyingPersons] = useState([]);

   // useEffect para observar cambios en reservationData
   useEffect(() => {
    console.log('Datos de reserva actualizados:', reservationData);
    // Aquí puedes añadir lógica adicional si necesitas manipular los datos o desencadenar otras acciones.
  }, [reservationData]);

  // useEffect para observar cambios en accompanyingPersons
  useEffect(() => {
    console.log('Lista de acompañantes actualizada:', accompanyingPersons);
    // También puedes realizar actualizaciones en la UI o acciones adicionales aquí.
  }, [accompanyingPersons]);

  // Ya existente: solo muestra por consola los datos de reserva
useEffect(() => {
  console.log('Datos de reserva actualizados:', reservationData);
}, [reservationData]);

useEffect(() => {
  if (
    !roomTypeInitialized &&
    reservationData?.reserva?.categoriaHabitacion &&
    roomTypeOptions.includes(reservationData.reserva.categoriaHabitacion)
  ) {
    setSelectedRoomTypes([reservationData.reserva.categoriaHabitacion]);
    setRoomTypeInitialized(true);
  }
}, [reservationData, roomTypeOptions, roomTypeInitialized]);


// NUEVO: Detecta si la reserva ya tiene habitación asignada
useEffect(() => {
  if (reservationData?.reserva?.roomId) {
    console.log("Asignación previa detectada:", reservationData.reserva.roomId);
    setSelectedRoom({
      roomId: reservationData.reserva.roomId,
      status: '',
      roomCategory: ''
    });
    setIsCheckInEnabled(true);
  } else {
    setSelectedRoom(null);
    setIsCheckInEnabled(false);
  }
}, [reservationData]);

  const handleChange = (e) => {
    setConfirmationId(e.target.value);
  };

  const buscarReserva = async (id) => {
    setIsLoading(true);
    try {
      const data = await getReservaPorConfirmationId(id); // Llamada a la API
      if (data) {
        setReservationData(data);
        setClienteId(data.cliente.idCliente); // Almacena el idCliente aquí
        setError('');
        setFormData({
          email: data.cliente.email || '',
          rut: data.cliente?.rut || '',
          identificationType: data.cliente?.identificationType || '3',
          nameFirst: data.cliente.nombres || '',
          nameSur: data.cliente.apellidoPaterno || '',
          phoneNumber: data.cliente.telefono || '',
          address1: data.cliente.direccion || '',
          address2: data.cliente.comuna || '',
          city: data.cliente.ciudad || '',
          countryCode: data.cliente.pais || '',
          codigoPais: data.cliente?.codigoPais || '',
          codigoPostal: data.cliente.codigoPostal || '',
          taxType: data.taxTypeType?.Code || '',
          hotelId: data.hotelId || '',
          reservationId: data.reserva?.idReserva || '',
          profileId: data.cliente?.idProfile || '',
          FechaNacimiento: data.cliente?.fechaNacimiento || '',
          Language: data.cliente?.language || 'ES',
          fechaNacimiento: data.cliente?.fechaNacimiento || '',
          currencyCode: data.cliente?.currencyCode || 'CLP',
        });
      } else {
        setError('No se encontraron datos para este código de confirmación.');
        setReservationData(null);
      }
    } catch (err) {
      console.error(err);
      setError('Error al buscar la reserva. Verifica el ID.');
      setReservationData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRoomModalOpen = async () => {
    if (!reservationData) {
        alert('Primero debes buscar una reserva válida.');
        return;
    }
    setIsLoadingRooms(true);
    setRoomError('');
    try {
      const roomSearchParameters = {
        HotelCode: reservationData.hotelId,
        HotelRoomStatus: selectedRoomStatuses,
        HotelFORoomStatus: ['Vacant'], // siempre fijo
        RoomTypes: selectedRoomTypes,
        PerfectFitRoomsOnly: false,
        ReservationId: reservationData.reserva.idReserva
      };

      console.log('roomSearchParameters:', roomSearchParameters);
    
      const rooms = await buscarHabitacionesDisponibles(roomSearchParameters);
      setAvailableRooms(rooms);
    } catch (error) {
        setRoomError('Error al buscar habitaciones disponibles.');
        console.error(error);
    } finally {
        setIsLoadingRooms(false);
        setShowRoomModal(true);
    }
};

const handleRoomModalClose = () => setShowRoomModal(false);

const handleSelectRoom = (room) => {
  console.log("Habitación seleccionada (room):", room);
  console.log("roomId:", room.room?.roomId); // correcto con la forma del objeto

  setSelectedRoom({
    roomId: room.room?.roomId ?? null,
    status: room.status ?? '',
    roomCategory: room.roomCategory ?? ''
  });

  setShowRoomModal(false);
};

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
  
    if (!/^\d+$/.test(inputConfirmationId.trim()) || inputConfirmationId.trim() === '') {
      setError('El confirmationId debe ser un número.');
      setReservationData(null);
    } else {
      setConfirmationId(inputConfirmationId); // Seteamos el ID solo cuando se presiona "Buscar"
      buscarReserva(inputConfirmationId);
    }
  };

  const handleSubmitEdit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);
    console.log(formData);

    try {
        // Actualizar datos del cliente principal
        const mainProfileResponse = await actualizarPerfilHuesped(
            formData,
            clienteId
        );
        console.log("Cliente principal actualizado:", mainProfileResponse);

        // Obtener los ID de los acompañantes actuales en la reserva
        const existingGuests = reservationData.accompanyGuests.map(guest => guest.idCliente);

        // Si no hay acompañantes nuevos ni existentes, actualizar la reserva con una lista vacía
        if (accompanyingPersons.length === 0 && existingGuests.length === 0) {
            console.log("No hay acompañantes, actualizando reserva sin acompañantes.");
            const reservationResponse = await UpdateReservation(
                reservationData.hotelId,
                reservationData.reserva.idReserva,
                new ReservationDetails(
                    reservationData.reserva.idReserva,
                    reservationData.cliente.idCliente,
                    [] // Lista vacía de acompañantes
                )
            );

            setReservationData((prevData) => ({
                ...prevData,
                accompanyGuests: [] // Vaciar la lista de acompañantes en el estado
            }));
            
        }

        // Crear perfiles de acompañantes nuevos (los que no tienen idCliente)
        let accompanyingProfiles = [];
        if (accompanyingPersons.length > 0) {
            accompanyingProfiles = await Promise.all(
                accompanyingPersons
                    .filter(person => !person.idCliente) // Solo los nuevos
                    .map(async (person) => {
                        const profileDetails = new ProfileDetails(person);
                        const response = await CreateProfile({ profileDetails });
                        return response; // ID del nuevo perfil
                    })
            );
        }

        console.log("Perfiles creados:", accompanyingProfiles);

        // Definir todos los perfiles de la reserva (cliente principal + acompañantes)
        const allProfiles = [
            reservationData.cliente.idCliente,
            ...existingGuests,
            ...accompanyingProfiles
        ];

        console.log("Todos los perfiles antes de eliminar duplicados:", allProfiles);

        // Eliminar duplicados asegurando que todos sean strings
        const uniqueProfiles = [...new Set(allProfiles.map(profile => String(profile)))];

        console.log("Perfiles únicos después de eliminar duplicados:", uniqueProfiles);

        // Construir detalles de la reserva
        const reservationDetails = new ReservationDetails(
            reservationData.reserva.idReserva,
            reservationData.cliente.idCliente,
            uniqueProfiles.slice(1) // Acompañantes sin incluir el cliente principal
        );

        console.log("Detalles de la reserva a actualizar:", JSON.stringify(reservationDetails, null, 2));

        // Enviar la actualización de la reserva
        const reservationResponse = await UpdateReservation(
            reservationData.hotelId,
            reservationData.reserva.idReserva,
            reservationDetails
        );

        console.log("Reserva actualizada con éxito:", reservationResponse);

        // Actualizar estado local con los nuevos acompañantes
        const updatedGuests = [
            ...reservationData.accompanyGuests.filter(guest =>
                uniqueProfiles.includes(String(guest.idCliente))
            ),
            ...accompanyingPersons
                .filter(person => !existingGuests.includes(person.idCliente)) // Solo nuevos
                .map((person, index) => ({
                    ...person,
                    idCliente: accompanyingProfiles[index] // Asignar nuevo ID
                }))
        ];

        setReservationData((prevData) => ({
            ...prevData,
            accompanyGuests: updatedGuests.length > 0 ? updatedGuests : [] // Vaciar si no hay acompañantes
        }));

        if (description && description.trim() !== "") {
          try {
            console.log(reservationData.reserva);
            
            await createAlert(reservationData.hotelId, reservationData.reserva.idReserva, description.trim());
            console.log("Alerta creada exitosamente");
            setDescription("");     // ← limpiamos el textarea
          } catch (alertError) {
            console.warn("No se pudo crear la alerta:", alertError);
          }
        }

        setIsLoading(false);
        alert("Actualización completada con éxito ✅");

        // 🔄 REFRESH tras guardar
        await buscarReserva(confirmationId || inputConfirmationId);
    } catch (error) {
        setError(error.message);
        console.error("Error en el proceso:", error);
        //alert("Ocurrió un error durante el proceso de actualización ⚠️");
        alert(`Error: ${error.message}`);
    } finally {        
        setIsLoading(false);
    }
};

const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
        ...prevData,
        [name]: value,
    }));
};

const handleAccompanyingChange = (index, e) => {
    const { name, value } = e.target;
    const updatedAccompanying = [...accompanyingPersons];
    updatedAccompanying[index][name] = value;
    setAccompanyingPersons(updatedAccompanying);
};

const handleAddAccompanying = () => {
    setAccompanyingPersons([...accompanyingPersons, { nombre: '', apellido: '' }]);
};

const handleRemoveAccompanying = (index) => {
    const updatedAccompanying = accompanyingPersons.filter((_, i) => i !== index);
    setAccompanyingPersons(updatedAccompanying);
};

const handleRemoveGuest = (idCliente) => {
    setReservationData((prevData) => {
        const updatedGuests = prevData.accompanyGuests.filter(guest => guest.idCliente !== idCliente);
        console.log("Acompañantes después de eliminar:", updatedGuests);
        return {
            ...prevData,
            accompanyGuests: updatedGuests.length > 0 ? updatedGuests : [] // Vaciar si no hay acompañantes
        };
    });
};

const handleModalFormChange = (e) => {
    const { name, value } = e.target;
    setModalFormData(prevState => ({
        ...prevState,
        [name]: value
    }));
};

const handleModalSearch = async (e, newOffset = null) => {
  if (e && e.preventDefault) e.preventDefault();
  setModalIsLoading(true);
  setModalError('');
  setHasSearched(true);

  const offsetToUse = newOffset !== null ? newOffset : modalPagination.offset;

  try {
    const searchResults = await getBuscarReservas({
      givenName: modalFormData.givenName,
      surname: modalFormData.surname,
      arrivalStartDate: modalFormData.arrivalStartDate,
      departureStartDate: modalFormData.departureStartDate,
      roomType: modalFormData.roomType,
      offset: offsetToUse,
      limit: modalPagination.limit
    });

    const formattedResults = Array.isArray(searchResults?.reservations?.reservationInfo)
      ? searchResults.reservations.reservationInfo
      : [];

    setModalSearchResults(formattedResults);

    setModalPagination(prev => ({
      ...prev,
      offset: offsetToUse,
      totalResults: searchResults.reservations.totalResults || 0
    }));

    if (!searchResults || formattedResults.length === 0) {
      setModalError('No se encontraron reservas con los criterios especificados.');
    }
  } catch (error) {
    console.error('Error buscando reservas:', error);
    setModalError('Error al buscar reservas. Por favor, intente nuevamente.');
    setModalSearchResults([]);
  } finally {
    setModalIsLoading(false);
  }
};


return (
  <Container fluid className="p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
    <NavBar />
    <Row className="justify-content-center">
      <Col xl={10} lg={12} md={12}>
        <Card className="shadow-lg border-0 rounded-lg mt-4">
          <Card.Header className="bg-primary text-white">
            <h3 className="mb-0">Buscar reserva por número de confirmación</h3>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4">
                <Col md={8}>
                  <Form.Group controlId="formConfirmationId">
                    <Form.Label className="fw-bold">Número de confirmación</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        value={inputConfirmationId}
                        onChange={handleChanged}
                        placeholder="Ingresa el número de confirmación"
                        disabled={!!confirmationId}
                        className="py-2"
                      />
                      {isLoading && (
                        <InputGroup.Text>
                          <Spinner animation="border" size="sm" />
                        </InputGroup.Text>
                      )}
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex gap-3">
                {!confirmationId && (
                  <>
                    <Button 
                      variant="primary" 
                      type="submit" 
                      disabled={isLoading}
                      className="px-4 py-2"
                    >
                      {isLoading ? 'Buscando...' : 'Buscar'}
                    </Button>

                    <Button 
                      variant="outline-secondary" 
                      onClick={handleModalOpen}
                      className="px-4 py-2"
                    >
                      Búsqueda Alternativa
                    </Button>
                  </>
                )}

                {confirmationId && (
                  <Button
                    variant="outline-danger"
                    onClick={handleExitReservation}
                    className="px-4 py-2"
                  >
                    Salir de la reserva actual
                  </Button>
                )}
              </div>
              
              {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            </Form>
          </Card.Body>
        </Card>

        {reservationData && (
          <div className="mt-4">
            {/* Reservation Summary Card */}
            <Card className="shadow-sm mb-4">
              <Card.Header className="bg-light">
                <h4 className="mb-0">Resumen de Reserva</h4>
              </Card.Header>
              <Card.Body>
                <Table responsive bordered hover className="mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Nombre</th>
                      <th>Email</th>
                      <th>Teléfono</th>
                      <th>Check-In</th>
                      <th>Check-Out</th>
                      <th>Habitación</th>
                      <th>Categoría</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {reservationData.cliente.nombres} {reservationData.cliente.apellidoPaterno}
                      </td>
                      <td>{reservationData.cliente.email}</td>
                      <td>
                        {reservationData.cliente.countryCode && `+${reservationData.cliente.countryCode}`} {reservationData.cliente.telefono}
                      </td>
                      <td>
                        <Badge bg="success" className="fs-6">
                          {new Date(reservationData.reserva.fechaCheckIn).toLocaleDateString('es-CL')}
                        </Badge>
                      </td>
                      <td>
                        <Badge bg="danger" className="fs-6">
                          {new Date(reservationData.reserva.fechaCheckOut).toLocaleDateString('es-CL')}
                        </Badge>
                      </td>
                      <td>
                        <Badge bg="info" className="fs-6">
                          {selectedRoom ? selectedRoom.roomId : reservationData.reserva.roomId || 'N/A'}
                        </Badge>
                      </td>
                      <td>{reservationData.reserva.categoriaHabitacion}</td>
                      <td>{reservationData?.reserva?.reservationStatus || 'N/A'}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>

            {reservationData.alerts?.length > 0 && (
              <div className="card mt-3">
                <div className="card-body">
                  <h5 className="card-title">Alertas de la Reserva</h5>
                  <ul className="list-group list-group-flush">
                    {reservationData.alerts.map((alert, index) => (
                      <li key={index} className="list-group-item">
                        <strong>{alert.code}</strong>: {alert.description} <span className="text-muted">({alert.area})</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {reservationData.comments?.length > 0 && (
              <div className="card mt-3">
                <div className="card-body">
                  <h5 className="card-title">Comentarios</h5>
                  <ul className="list-group list-group-flush">
                    {reservationData.comments.map((c, index) => (
                      <li key={index} className="list-group-item">
                        {c.comment?.text?.value}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {reservationData.guestMessages?.length > 0 && (
              <div className="card mt-3">
                <div className="card-body">
                  <h5 className="card-title">Mensajes del Huésped</h5>
                  <ul className="list-group list-group-flush">
                    {reservationData.guestMessages.map((m, index) => (
                      <li key={index} className="list-group-item">
                        {m.message?.messageText}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}


            {/* Edit Form */}
            <Card className="shadow-sm mb-4">
              <Card.Header className="bg-light">
                <h4 className="mb-0">Editar Información de Reserva</h4>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={handleSubmitEdit}>
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label className="fw-bold">Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formNameFirst">
                        <Form.Label className="fw-bold">Nombre</Form.Label>
                        <Form.Control
                          type="text"
                          name="nameFirst"
                          value={formData.nameFirst}
                          onChange={handleFormChange}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formNameSur">
                        <Form.Label className="fw-bold">Apellido</Form.Label>
                        <Form.Control
                          type="text"
                          name="nameSur"
                          value={formData.nameSur}
                          onChange={handleFormChange}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    

                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formIdentification">
                        <Form.Label className="fw-bold">Identificación</Form.Label>

                        <div className="d-flex align-items-center gap-4 mb-2">
                          <Form.Check
                            inline
                            type="radio"
                            id="idTypeRut"
                            name="identificationType"
                            label="RUT"
                            value="3"
                            checked={formData.identificationType === '3'}
                            onChange={handleFormChange}
                          />
                          <Form.Check
                            inline
                            type="radio"
                            id="idTypePassport"
                            name="identificationType"
                            label="Pasaporte"
                            value="5"
                            checked={formData.identificationType === '5'}
                            onChange={handleFormChange}
                          />
                        </div>

                        <Form.Control
                          type="text"
                          name="rut"
                          value={formData.rut}
                          onChange={handleFormChange}
                          placeholder={formData.identificationType === '3' ? '12345678-9' : 'Ingrese número de pasaporte'}
                          autoComplete="off"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formFechaNacimiento">
                        <Form.Label className="fw-bold">Fecha de Nacimiento</Form.Label>
                        <Form.Control
                          type="date"
                          name="FechaNacimiento"
                          value={formData.FechaNacimiento || ''}
                          onChange={handleFormChange}
                          max={new Date().toISOString().split('T')[0]}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group className="mb-3" controlId="formCodigoPais">
                        <Form.Label className="fw-bold">Código País</Form.Label>
                        <Form.Select
                          name="codigoPais"
                          value={formData.codigoPais || ''}
                          onChange={handleFormChange}
                        >
                          {countryCodes.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name} ({country.code})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formPhoneNumber">
                        <Form.Label className="fw-bold">Teléfono</Form.Label>
                        <Form.Control
                          type="text"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleFormChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formLanguage">
                        <Form.Label className="fw-bold">Idioma</Form.Label>
                        <Form.Select
                          name="Language"
                          value={formData.Language || 'ES'}
                          onChange={handleFormChange}
                        >
                          <option value="ES">Español</option>
                          <option value="EN">Inglés</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={8}>
                      <Form.Group className="mb-3" controlId="formAddress1">
                        <Form.Label className="fw-bold">Dirección</Form.Label>
                        <Form.Control
                          type="text"
                          name="address1"
                          value={formData.address1}
                          onChange={handleFormChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formCodigoPostal">
                        <Form.Label className="fw-bold">Código Postal</Form.Label>
                        <Form.Control
                          type="text"
                          name="codigoPostal"
                          value={formData.codigoPostal}
                          onChange={handleFormChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3" controlId="formCountryCode">
                        <Form.Label className="fw-bold">País</Form.Label>
                        <Form.Select
                          name="countryCode"
                          value={formData.countryCode || 'CL'}
                          onChange={handleFormChange}
                        >
                          {countriesISO.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name} ({country.code})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    
                    <Col md={3}>
                      <Form.Group className="mb-3" controlId="formCity">
                        <Form.Label className="fw-bold">Ciudad</Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleFormChange} 
                          placeholder="Ingrese la ciudad"                         
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId="formAddress2" className="mb-3">
                        <Form.Label>Estado o Comuna</Form.Label>
                        <Form.Control
                          type="text"
                          name="address2"
                          value={formData.address2}
                          onChange={handleFormChange}                          
                        />
                      </Form.Group>
                    </Col>                    

                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Moneda</Form.Label>
                        <Form.Select
                          name="currencyCode"
                          value={formData.currencyCode || "CLP"}
                          onChange={handleFormChange}
                        >
                          <option value="CLP">CLP</option>
                          <option value="USD">USD</option>
                          <option value="EUR">EUR</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col md={6}>
                      <Form.Group controlId="formTaxType">
                        <Form.Label className="fw-bold">Tipo de Contribuyente</Form.Label>
                        <Form.Control
                          as="select"
                          name="taxType"
                          value={formData.taxType}
                          onChange={handleFormChange}
                        >
                          <option value="">Seleccione</option>
                          <option value="BOL">BOL</option>
                          <option value="FAN">FAN</option>
                          <option value="FEX">FEX</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                    <Form.Group controlId="formPostingRestriction" className="mb-3">
                      <Form.Check
                        type="checkbox"
                        name="postingRestriction"
                        label="Restringir cargos NoPost"
                        checked={!!formData.postingRestriction}
                        onChange={(e) =>
                          setFormData(prev => ({ ...prev, postingRestriction: e.target.checked }))
                        }
                      />
                    </Form.Group>
                  </Col>

                  </Row>
                  <br></br>

                  {/* Room Assignment Section */}
                  <div className="bg-light p-3 rounded mb-4">
                    <h5 className="mb-3">Asignación de Habitación</h5>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-bold">Estado de Habitación</Form.Label>
                          <div className="d-flex flex-wrap gap-3">
                            {roomStatusesOptions.map((status) => (
                              <Form.Check
                                key={status}
                                type="checkbox"
                                id={`status-${status}`}
                                label={status}
                                checked={selectedRoomStatuses.includes(status)}
                                onChange={() => {
                                  setSelectedRoomStatuses(prev =>
                                    prev.includes(status)
                                      ? prev.filter(s => s !== status)
                                      : [...prev, status]
                                  );
                                }}
                              />
                            ))}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="roomTypes">
                          <Form.Label className="fw-bold">Categorías de Habitación</Form.Label>
                          <Form.Select
                            value={selectedRoomTypes[0] || ''}
                            onChange={(e) => {
                              setSelectedRoomTypes([e.target.value]);
                            }}
                          >
                            <option value="" disabled>Seleccione una categoría</option>
                            {roomTypeOptions.map(type => (
                              <option key={type} value={type}>{type}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="d-flex align-items-center gap-3">
                      <Button 
                        variant="info" 
                        onClick={handleRoomModalOpen}
                        className="px-4"
                      >
                        Buscar Habitación
                      </Button>

                      {selectedRoom && (
                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-bold">Habitación seleccionada:</span>
                          <Badge bg="primary" className="fs-6">
                            {selectedRoom.roomId}
                          </Badge>
                          <Button
                            variant="primary"
                            onClick={handleAssignRoom}
                            disabled={isAssigningRoom}
                            className="px-3"
                          >
                            {isAssigningRoom ? (
                              <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Asignando...
                              </>
                            ) : "Asignar"}
                          </Button>
                        </div>
                      )}
                    </div>
                    {assignmentError && <Alert variant="danger" className="mt-2">{assignmentError}</Alert>}
                  </div>

                  {/* Accompanying Guests */}
                  <div className="mb-4">
                    <h5 className="mb-3">Acompañantes</h5>
                    {reservationData.accompanyGuests.length > 0 ? (
                      <Table responsive bordered hover>
                        <thead className="table-light">
                          <tr>
                            <th>ID Perfil</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reservationData.accompanyGuests.map((guest) => (
                            <tr key={guest.idCliente}>
                              <td>{guest.idCliente}</td>
                              <td>{guest.nombre}</td>
                              <td>{guest.apellido}</td>
                              <td>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => handleRemoveGuest(guest.idCliente)}
                                >
                                  Quitar
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <Alert variant="info">No hay acompañantes registrados</Alert>
                    )}

                    <Button 
                      variant="outline-secondary" 
                      onClick={handleAddAccompanying}
                      className="mt-2"
                    >
                      Añadir Acompañante
                    </Button>

                    {accompanyingPersons.length > 0 && (
                      <div className="mt-3 p-3 bg-light rounded">
                        {accompanyingPersons.map((person, index) => (
                          <div key={index} className="mb-3 p-3 bg-white rounded shadow-sm">
                            <Row>
                              <Col md={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Nombre</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="nombre"
                                    value={person.nombre}
                                    onChange={(e) => handleAccompanyingChange(index, e)}
                                    required
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Apellido</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="apellido"
                                    value={person.apellido}
                                    onChange={(e) => handleAccompanyingChange(index, e)}
                                    required
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Teléfono</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="phonenumber"
                                    value={person.phonenumber}
                                    onChange={(e) => handleAccompanyingChange(index, e)}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={8}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Dirección</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="direccion"
                                    value={person.direccion}
                                    onChange={(e) => handleAccompanyingChange(index, e)}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4} className="d-flex align-items-end">
                                <Button
                                  variant="danger"
                                  onClick={() => handleRemoveAccompanying(index)}
                                  className="w-100"
                                >
                                  Quitar
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-bold">Observaciones/Notas</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Ingrese cualquier observación adicional sobre la reserva..."
                      value={description}  // Asegúrate de tener este estado definido
                      onChange={(e) => setDescription(e.target.value)}  // Y su handler
                    />
                  </Form.Group>

                  {/* Action Buttons */}
                  <div className="d-flex flex-wrap gap-3">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      disabled={isLoading}
                      className="px-4 py-2"
                    >
                      {isLoading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Guardando...
                        </>
                      ) : "Guardar Cambios"}
                    </Button>

                    <Button
                      variant="success"
                      onClick={handleCheckIn}
                      disabled={!isCheckInEnabled || isPerformingCheckIn}
                      className="px-4 py-2"
                    >
                      {isPerformingCheckIn ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Procesando...
                        </>
                      ) : "Realizar Check-In"}
                    </Button>

                    <Button
                      variant="warning"
                      className="px-4 py-2"
                      disabled={!canCreateKey}
                    >
                      Crear Llave
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        )}

        {/* Room Modal */}
        <Modal show={showRoomModal} onHide={handleRoomModalClose} size="lg">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>Habitaciones Disponibles</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoadingRooms ? (
              <div className="text-center py-4">
                <Spinner animation="border" role="status" className="me-2" />
                <span>Cargando habitaciones...</span>
              </div>
            ) : roomError ? (
              <Alert variant="danger">{roomError}</Alert>
            ) : availableRooms.length > 0 ? (
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead className="table-light">
                    <tr>
                      <th>Número</th>
                      <th>Estado</th>
                      <th>Categoría</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {availableRooms.map((room, index) => (
                      <tr key={index}>
                        <td>{room.room.roomId}</td>
                        <td>
                          <Badge bg={
                            room.status === 'Disponible' ? 'success' : 
                            room.status === 'Ocupada' ? 'danger' : 'warning'
                          }>
                            {room.status}
                          </Badge>
                        </td>
                        <td>{room.roomCategory}</td>
                        <td>
                          <Button 
                            variant="success" 
                            size="sm"
                            onClick={() => handleSelectRoom(room)}
                          >
                            Seleccionar
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <Alert variant="info">No hay habitaciones disponibles con los filtros seleccionados</Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleRoomModalClose}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Alternative Search Modal */}
        <Modal show={showModal} onHide={handleModalClose} size="xl">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>Búsqueda Alternativa de Reservas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleModalSearch}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formGivenName">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      name="givenName"
                      placeholder="Ingrese el nombre"
                      value={modalFormData.givenName}
                      onChange={handleModalFormChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formSurname">
                    <Form.Label>Apellido</Form.Label>
                    <Form.Control
                      type="text"
                      name="surname"
                      placeholder="Ingrese el apellido"
                      value={modalFormData.surname}
                      onChange={handleModalFormChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formArrivalStartDate">
                    <Form.Label>Categoría Habitación</Form.Label>
                    <Form.Control
                      as="select"
                      name="roomType"
                      value={modalFormData.roomType}
                      onChange={handleModalFormChange}
                    >
                      <option value="">Seleccione</option>
                      {roomTypeOptions.map(rt => (
                        <option key={rt} value={rt}>{rt}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formArrivalStartDate">
                    <Form.Label>Fecha de Llegada</Form.Label>
                    <Form.Control
                      type="date"
                      name="arrivalStartDate"
                      value={modalFormData.arrivalStartDate}
                      onChange={handleModalFormChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formDepartureStartDate">
                    <Form.Label>Fecha de Salida</Form.Label>
                    <Form.Control
                      type="date"
                      name="departureStartDate"
                      value={modalFormData.departureStartDate}
                      onChange={handleModalFormChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-between">
                <Button 
                  variant="primary" 
                  type="submit" 
                  disabled={modalIsLoading}
                  className="px-4"
                  onClick={() => setModalPagination(prev => ({ ...prev, offset: 0 }))}
                >
                  {modalIsLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Buscando...
                    </>
                  ) : "Buscar Reservas"}
                </Button>
                <Button 
                  variant="outline-secondary" 
                  onClick={handleModalClose}
                  className="px-4"
                >
                  Cancelar
                </Button>
              </div>
            </Form>

            {modalSearchResults && modalSearchResults.length > 0 && (
              <div className="mt-4">
                <h5 className="mb-3">Resultados de Búsqueda</h5>
                <div className="table-responsive">
                  <Table striped bordered hover>
                    <thead className="table-light">
                      <tr>
                        <th>ID Reserva</th>
                        <th>Nombre</th>
                        <th>Apellido</th>
                        <th>Room</th>
                        <th>Estado Habitación</th>
                        <th>Check-In</th>
                        <th>Check-Out</th>
                        <th>Categoría</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modalSearchResults.map((reserva, index) => {
                        const { reservationIdList, roomStay, reservationGuest } = reserva;
                        
                        const handleSelectReservation = async (reservationId) => {
                          setSelectedReservationId(reservationId);
                          setConfirmationId(reservationId); // Guarda el ID en el estado
                          handleModalClose(); // Cierra el modal inmediatamente
                          setInputConfirmationId(reservationId); // Actualiza el input con el ID seleccionado
                        
                          await buscarReserva(reservationId); // Llamar a la API para obtener los datos inmediatamente
                        };
                        const handleDesasignarHabitacion = async (reservationId) => { 
                          const confirmar = window.confirm("¿Está seguro que desea desasignar esta habitación?");
                          if (!confirmar) return;

                          try{
                            setDesasignandoId(reservationId); // Inicia loading en esta fila
                            console.log("reserva "+ reserva.hotelId + " " + reservationId);                         
                            
                            const resultado = await removerHabitacionAsignada(reserva.hotelId, reservationId);
                            if (resultado === true) {
                              setDesasignadoExitosoId(reservationId);

                              setModalSearchResults(prev =>
                                prev.map(item =>
                                  item.reservationIdList?.[0]?.id === reservationId
                                    ? {
                                        ...item,
                                        roomStay: {
                                          ...item.roomStay,
                                          roomId: null,
                                          roomType: item.roomStay?.roomType || 'N/A'  // opcional
                                        }
                                      }
                                    : item
                                )
                              );
                            }

                            setSelectedRoom(null);
                            setReservationData(prev => {
                              if (!prev || !prev.reserva) return prev;

                              return {
                                ...prev,
                                reserva: {
                                  ...prev.reserva,
                                  roomId: null,
                                  roomType: null
                                }
                              };
                            });
                          }
                          catch (error) {
                            console.error("Error al desasignar habitación:", error);
                          } finally {
                            setDesasignandoId(null); // Finaliza loading
                            setTimeout(() => setDesasignadoExitosoId(null), 3000);
                          }
                        };

                        const reservationId = reservationIdList?.[1]?.id || 'N/A';

                        const formatDateDDMMYYYY = (dateStr) => {
                          const [year, month, day] = new Date(dateStr).toISOString().slice(0, 10).split("-");
                          return `${day}-${month}-${year}`;
                        };
                        //const arrivalDate = roomStay?.arrivalDate ? new Date(roomStay.arrivalDate).toLocaleDateString('es-CL') : 'N/A';
                        const arrivalDate = roomStay?.arrivalDate
                          ? formatDateDDMMYYYY(roomStay.arrivalDate)
                          : 'N/A';

                        //const departureDate = roomStay?.departureDate ? new Date(roomStay.departureDate).toLocaleDateString('es-CL') : 'N/A';
                        const departureDate = roomStay?.departureDate
                          ? formatDateDDMMYYYY(roomStay.departureDate)
                          : 'N/A';

                        const ratePlanCode = roomStay?.ratePlanCode || 'N/A';
                        const guestFirstName = reservationGuest?.givenName || 'N/A';
                        const guestLastName = reservationGuest?.surname || 'N/A';
                        const email = reserva.email || 'N/A';
                        const habitacion = (reserva.roomStay?.roomType || 'N/A') + '/' + (reserva.roomStay?.roomId || 'N/A')

                        const roomStatus =
                          reserva.roomStatus ??
                          reserva.roomStatus ??
                          'N/A';
                        
                        return (
                          <tr key={index}>
                            <td>{reservationId}</td>
                            <td>{guestFirstName}</td>
                            <td>{guestLastName}</td>
                            <td>{habitacion}</td>
                            <td>{roomStatus}</td>
                            <td>{arrivalDate}</td>
                            <td>{departureDate}</td>
                            <td>{ratePlanCode}</td>
                            <td>
                              <div style={{ display: "flex", gap: "6px" }}>
                                <Button variant="warning" size="sm" 
                                  onClick={() => handleDesasignarHabitacion(reservationIdList?.[0]?.id)} 
                                  disabled={!roomStay?.roomId}
                                  >
                                  {desasignandoId === reservationIdList?.[0]?.id ? (
                                    <>
                                      <Spinner animation="border" size="sm" className="me-2" />
                                      Desasignando...
                                    </>
                                  ) : desasignadoExitosoId === reservationIdList?.[0]?.id ? (
                                    <>
                                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                                      Desasignado
                                    </>
                                  ) : (
                                    "Desasignar"
                                  )}
                                </Button>
                                <Button variant="primary" size="sm" onClick={() => handleSelectReservation(reservationId)}>
                                  Seleccionar
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <Button
                        variant="outline-primary"
                        disabled={modalPagination.offset === 0}
                        onClick={(e) => handleModalSearch(e, modalPagination.offset - modalPagination.limit)}
                      >
                        Anterior
                      </Button>

                      <span className="fw-bold">
                        Página {Math.floor(modalPagination.offset / modalPagination.limit) + 1} de{" "}
                        {Math.ceil(modalPagination.totalResults / modalPagination.limit)}
                      </span>

                      <Button
                        variant="outline-primary"
                        disabled={modalPagination.offset + modalPagination.limit >= modalPagination.totalResults}
                        onClick={(e) => handleModalSearch(e, modalPagination.offset + modalPagination.limit)}
                      >
                        Siguiente
                      </Button>
                    </div>

                </div>
              </div>
            )}

            {hasSearched && !modalIsLoading && modalSearchResults.length === 0 && (
              <Alert variant="info" className="mt-4">
                No se encontraron reservas que coincidan con los criterios de búsqueda
              </Alert>
            )}

            {modalError && (
              <Alert variant="danger" className="mt-3">
                {modalError}
              </Alert>
            )}
          </Modal.Body>
        </Modal>

        <Modal show={!!checkInError} onHide={() => setCheckInError("")}>
          <Modal.Header closeButton>
            <Modal.Title>Error al realizar el Check-In</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {checkInError}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setCheckInError("")}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

      </Col>
    </Row>
    <Footer />
  </Container>
);
};

export default FormularioBusquedaReserva;
